import type { FC } from 'react';

import LiveTag from 'app/components/LiveTag';

import style from './style.module.scss';

interface Props {
  data: NameBlockMatch;
  isLive: boolean;
}

const MatchName: FC<Props> = ({ data, isLive }) => {
  const subtitleParts = [data.serie_full_name, data.tournament_name].filter(Boolean);

  return (
    <div className={style.matchName}>
      <div className={style.titleRow}>
        <span className={style.title}>{data.league_name}</span>
        {isLive && <LiveTag className={style.liveTag} />}
      </div>
      {subtitleParts.length > 0 && (
        <div className={style.subtitle}>
          {subtitleParts.map((part, index) => (
            <span key={part} className={style.subtitlePart}>
              {index > 0 && <span className={style.subtitleDivider} />}
              {part}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

MatchName.displayName = 'MatchName';

export default MatchName;
